export default ["M0 8.33l9.17 2.5 2.5 9.17L20 0z"];
